export default "__VITE_ASSET__C27h1VZA__"